import "./Video.scss";

const Video = () => {
  return (
    <div className="Video-container-main">
      <div className="Video-title">
        <h2 id="Video" className="index">
          Music Video
        </h2>
      </div>
      <div className="Video-item">
        <ul>
        {/* <li>
            <div className="Video-mondai">
              <iframe
                src={`https://www.youtube.com/embed/bO278K8YhQY`}
                width="560"
                height="315"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay;clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </li> */}
        <li>
            <div className="Video-honno">
              <iframe
                src={`https://www.youtube.com/embed/DYpBuc5QPfM`}
                width="560"
                height="315"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay;clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </li>
          <li>
            <div className="Video-RUN">
              <iframe
                src={`https://www.youtube.com/embed/j3FzvBigoEk`}
                width="560"
                height="315"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay;clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </li>
         
        </ul>
      </div>
    </div>
  );
};

export default Video;
